import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import Loading from '../Loading';
import UserStore from '../../stores/UserStore';

function DataComponentTableOffer({ loading = false, data = [], className = '', columnData = { body: [] } }) {
    const t = useMemo(() => UserStore.getTranslation(), []);
    const staticNames = t?.dataTable || { noData: 'No data' };

    return (
        <div className="loading-wrapper">
            {loading && data.length ? <div className="loading-wrapper__item"><Loading /></div> : null}

            <div className={`offers__wrapper ${className}`}>
                {data.map((item, i) => {
                    const key = React.isValidElement(item?.id) ? i : (item?.id ?? i);
                    return (
                        <div className="offer" key={key}>
                            {Object.keys(item).map((k, j) => {
                                const cellCfg = columnData.body?.[j] || {};
                                let value;
                                if (typeof item[k] === 'object') value = item[k];
                                else if (typeof item[k] === 'string') value = Parser(item[k]);
                                if (value === undefined) return null;
                                return <div className={k} key={j} {...cellCfg}>{value}</div>;
                            })}
                        </div>
                    );
                })}

                {!data.length ? (loading ? <Loading center /> : <div className="text-center table-notfound-sign">{staticNames.noData}</div>) : null}
            </div>
        </div>
    );
}

DataComponentTableOffer.propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.array,
    className: PropTypes.string,
    columnData: PropTypes.shape({ body: PropTypes.array })
};

export default DataComponentTableOffer;
